
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Copporatebusserviceinpune() {



    const cardData =
    {
        keyword: ' Corporate Bus Services Pune',
        heading: 'etravo :  Corporate Bus Services Pune',
        headingDescription: 'eTravo provides premium Corporate Bus Services in Pune, tailored for business travel and employee transportation needs. Whether it’s daily office commutes, off-site meetings, team outings, or corporate events, we offer a fleet of AC and non-AC buses with seating capacities ranging from 20 to 50+ seats. Our buses come equipped with comfortable seating, professional drivers, and GPS tracking to ensure safety and punctuality. With a strong focus on corporate logistics, eTravo guarantees reliable, hassle-free, and cost-effective transport solutions for businesses across Pune.',

        top: 'Top Places to Visit in Pune with etravo',

        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada is a historical fortification in Pune, built in 1732 as the seat of the Peshwas of the Maratha Empire. Though much of the fort was destroyed by a fire in 1828, the surviving structures, including the massive gates and foundations, offer a glimpse into its majestic past. The site is known for its architectural grandeur and the evening light and sound show that narrates its rich history."
            },
            {
                "title": "Aga Khan Palace",
                "description": "Built in 1892, the Aga Khan Palace is a significant monument in Indian history. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace is renowned for its Italian arches, sprawling lawns, and the memorials of Gandhi and Kasturba. It now houses a museum dedicated to Gandhi's life and work."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Perched atop a hill about 30 km from Pune, Sinhagad Fort is a popular trekking destination. The fort has witnessed several battles, including the famous Battle of Sinhagad in 1670. Visitors can explore the ruins, enjoy panoramic views of the surrounding region, and savor local delicacies like 'pithla bhakri' sold by vendors at the summit."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This museum houses an extensive collection of over 20,000 artifacts, showcasing the everyday life of Indians in the past. From musical instruments and paintings to household items and sculptures, the museum offers a deep dive into India's rich cultural heritage."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Dating back to the 8th century, the Pataleshwar Cave Temple is a rock-cut temple dedicated to Lord Shiva. Carved out of a single basalt rock, the temple features intricate carvings and a unique circular Nandi mandapa. It's a serene spot amidst the bustling city."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in Koregaon Park, the Osho International Meditation Resort is a tranquil haven for those seeking peace and spiritual growth. The ashram offers various meditation programs and workshops in a lush, serene environment."
            },
            {
                "title": "Parvati Hill",
                "description": "Parvati Hill is one of the highest points in Pune, offering a panoramic view of the city. Atop the hill stands the Parvati Temple, dedicated to Goddess Parvati. The hill is a popular spot for morning walks and photography enthusiasts."
            },
            {
                "title": "Pune-Okayama Friendship Garden",
                "description": "Also known as Pu La Deshpande Garden, this is one of the largest Japanese-style gardens outside Japan. Inspired by the 300-year-old Okayama Korakuen Garden, it features manicured lawns, flowing streams, and picturesque bridges."
            },
            {
                "title": "Rajiv Gandhi Zoological Park",
                "description": "Spread over 130 acres, this zoo houses a variety of animals, including tigers, leopards, elephants, and reptiles. The park also features a snake park and a lake, making it a favorite among families and nature enthusiasts."
            },
            {
                "title": "Dagdusheth Halwai Ganapati Temple",
                "description": "This temple is one of the most famous Ganesh temples in India. Known for its rich history and the grand Ganesh Festival celebrations, the temple attracts thousands of devotees and tourists annually."
            }
        ],

        "services": [
            {
                "name": "Corporate Bus Rental in Pune",
                "description": "eTravo offers comprehensive corporate bus rental services in Pune, perfect for businesses looking for reliable transportation solutions. Whether you need buses for daily staff commutes, client transfers, or business events, our fleet is maintained to the highest standards and comes with experienced chauffeurs to ensure smooth and professional service."
            },
            {
                "name": "Bus Services for Corporate Events in Pune",
                "description": "Planning a corporate event in Pune? eTravo provides dedicated bus services for conferences, offsite meetings, team-building activities, and other business gatherings. Our transport coordination ensures your team arrives on time and in comfort, enhancing the efficiency and experience of your corporate event."
            },
            {
                "name": "Employee Transportation Solutions in Pune",
                "description": "eTravo delivers end-to-end employee transportation solutions in Pune tailored for startups, SMEs, and large enterprises. Our services include route planning, real-time tracking, flexible scheduling, and dependable buses to streamline your team's daily commute with safety and punctuality as our top priorities."
            },
            {
                "name": "Daily Office Commute Buses in Pune",
                "description": "Reduce stress and improve productivity with eTravo’s daily office commute bus services in Pune. We provide a fleet of clean, air-conditioned buses for routine employee travel, ensuring timely pickups and drop-offs across various office locations and residential zones."
            },
            {
                "name": "Luxury Corporate Buses in Pune",
                "description": "Elevate your business travel experience with eTravo’s luxury corporate buses in Pune. Equipped with reclining seats, air-conditioning, entertainment systems, and more, these buses are ideal for executive travel, premium business delegations, and important client transportation."
            },
            {
                "name": "Bus on Rent for Corporate Meetings in Pune",
                "description": "Need a bus rental for an upcoming corporate meeting in Pune? eTravo offers reliable and timely rentals designed for one-time or regular business meetups. With trained drivers and GPS-enabled buses, we ensure your staff or guests reach their destination comfortably and efficiently."
            },
            {
                "name": "Corporate Shuttle Services in Pune",
                "description": "eTravo’s corporate shuttle services in Pune are designed to support inter-campus travel, last-mile connectivity, and dedicated route management for your organization. Our customized shuttle plans help businesses reduce costs, enhance punctuality, and ensure employee satisfaction."
            },
            {
                "name": "Staff Transportation Bus in Pune",
                "description": "Ensure reliable and safe transportation for your workforce with eTravo’s staff transportation buses in Pune. Our scalable services can accommodate both small teams and large corporate setups, offering efficient scheduling, real-time monitoring, and customer support throughout the service."
            },
            {
                "name": "Affordable Corporate Bus Hire Pune",
                "description": "eTravo provides cost-effective corporate bus hire services in Pune without compromising on quality or comfort. Whether you need short-term or long-term rentals, we offer flexible pricing packages that align with your organization’s transportation budget."
            },
            {
                "name": "Air-Conditioned Corporate Bus Service in Pune",
                "description": "Travel in comfort no matter the weather with eTravo’s air-conditioned corporate bus service in Pune. All buses come equipped with modern climate control systems, ergonomic seating, and a smooth ride experience, ensuring your employees or guests are always transported in comfort."
            }
        ],
        "tableData": [
            ["Corporate Bus Rental in Pune", "Bus Services for Corporate Events in Pune"],
            ["Employee Transportation Solutions in Pune", "Daily Office Commute Buses in Pune"],
            ["Luxury Corporate Buses in Pune", "Bus on Rent for Corporate Meetings in Pune"],
            ["Corporate Shuttle Services in Pune", "Staff Transportation Bus in Pune"],
            ["Affordable Corporate Bus Hire Pune", "Air-Conditioned Corporate Bus Service in Pune"]
        ],







        "whychoose": [
            {
                "WhyChooseheading": "Punctual and Reliable Service",
                "WhyChoosedescription": "At eTravo, we understand the importance of time in the corporate world. Our corporate bus services in Pune are known for punctual pickups and drop-offs, ensuring your employees or clients arrive on time, every time."
            },
            {
                "WhyChooseheading": "Comfortable and Modern Fleet",
                "WhyChoosedescription": "eTravo offers a fleet of well-maintained, air-conditioned buses designed for comfort and convenience. Whether it’s a daily office commute or a corporate outing, our buses provide a smooth and relaxing travel experience."
            },
            {
                "WhyChooseheading": "Professional and Trained Drivers",
                "WhyChoosedescription": "Our drivers are experienced, courteous, and trained in corporate transport etiquette. They ensure a safe and professional journey, making eTravo a trusted choice for corporate bus services in Pune."
            },
            {
                "WhyChooseheading": "Transparent and Competitive Pricing",
                "WhyChoosedescription": "We offer clear and upfront pricing with no hidden charges. eTravo’s corporate bus services in Pune come at competitive rates, making it easy for businesses to plan budgets without any surprises."
            },
            {
                "WhyChooseheading": "Safety-First Approach",
                "WhyChoosedescription": "Safety is a top priority at eTravo. All our buses are equipped with GPS tracking, seat belts, fire extinguishers, and first-aid kits to ensure a secure journey for every passenger."
            },
            {
                "WhyChooseheading": "24/7 Operational Support",
                "WhyChoosedescription": "Our support team is available around the clock to assist with scheduling, route adjustments, or last-minute changes. eTravo ensures seamless coordination for all your corporate transportation needs."
            },
            {
                "WhyChooseheading": "Easy Booking and Management",
                "WhyChoosedescription": "With eTravo, booking corporate bus services in Pune is simple. Use our online platform for hassle-free scheduling and real-time updates, or connect with our support team for customized service."
            },
            {
                "WhyChooseheading": "Tailored Transport Solutions",
                "WhyChoosedescription": "Every business is different. That’s why eTravo offers customized transport solutions based on your company’s requirements—be it daily employee shuttles, event transportation, or long-distance corporate travel."
            }
        ]


















    }


    // Corporate Bus Services Pune – eTravo

    const faqData = [
        [
            {
                question: 'What types of corporate bus services does eTravo offer in Pune?',
                answer: 'eTravo provides premium corporate bus services in Pune, including employee transportation, corporate event transfers, and team outings. Our fleet includes AC buses, luxury coaches, and mini-buses tailored for corporate needs.',
            },
            {
                question: 'Can eTravo handle daily employee transportation for our company?',
                answer: 'Yes, eTravo specializes in daily staff commute solutions. We offer customizable routes and schedules to ensure timely and efficient transport for your employees.',
            },
            {
                question: 'Are eTravo’s buses equipped with safety and comfort features?',
                answer: 'Absolutely. Our corporate buses come with modern amenities like air conditioning, comfortable seating, GPS tracking, and regular maintenance checks to ensure safety and comfort.',
            },
            {
                question: 'How does eTravo ensure punctuality for corporate pickups and drops?',
                answer: 'Our operations team uses real-time GPS tracking and route optimization tools to ensure timely pickups and drops, maintaining a high standard of punctuality for corporate clients.',
            },
            {
                question: 'Can we book eTravo buses for corporate events or offsites?',
                answer: 'Yes, eTravo offers flexible booking options for corporate events, offsite meetings, and group travel. We work closely with companies to manage logistics and deliver a smooth travel experience.',
            },
            {
                question: 'Is there a dedicated point of contact for corporate accounts?',
                answer: 'Yes, eTravo provides a dedicated account manager for each corporate client to handle all booking needs, changes, and service requirements efficiently.',
            },
        ]
    ];

    const testimonialsData = [
        {
            name: 'Mr. Rakesh Patil',
            designation: 'HR Manager, TechNova Pvt. Ltd.',
            rating: [1, 1, 1, 1, 1],
            text: '“eTravo has streamlined our employee transport operations in Pune. Their buses are always on time, well-maintained, and the drivers are professional. A reliable partner for corporate travel.”',
        },
        {
            name: 'Ms. Priya Kulkarni',
            designation: 'Admin Head, Viora Solutions',
            rating: [1, 1, 1, 1, 1],
            text: '“We’ve used eTravo for several corporate offsites and internal events. The coordination is excellent, and their corporate-focused services have exceeded our expectations every time.”',
        },
    ];





















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Bus Services Pune",
  "image": "https://www.etravo.in/images/keyword/corporate-bus-service-pune.jpg",
  "description": "Book reliable and affordable Corporate Bus Services in Pune with eTravo. We offer air-conditioned buses for corporate events, daily office commutes, staff transportation, and executive meetings. Choose from luxury or budget-friendly options with experienced drivers and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5321"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-bus-services-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Corporate Bus Services Pune | Office Commute & Event Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate bus services in Pune with eTravo for staff transport, daily commutes, and event shuttle services. AC buses, reliable drivers, and affordable packages available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/1.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Copporatebusserviceinpune;